export const NO_RIGHTS_RESIZE_THIS_BOOKING = `Sorry, you do not have permission to resize this booking.`;
